import { createAction, props } from '@ngrx/store';
import { LobbyCheckIn } from 'src/app/lobby/shared/models/lobby-check-in';
import { AppointmentGridGroup } from 'src/app/shared/models/message-hub/appointmentGridGroupRequest';

export const setAppointmentStatusGridPagination = createAction(
    '[Appointment Status Grid] Set Appointment Status Grid Pagination',
    props<{ page: number, pageSize: number }>()
);

export const setAppointmentStatusGridSortOptions = createAction(
    '[Appointment Status Grid] Set Appointment Status Grid SortOptions',
    props<{ sortColumn: string, sortDirection: string }>()
);

export const setAppointmentStatusGridLocation = createAction(
  '[Appointment Status Grid] Set Appointment Status Grid Location',
  props<{ locationId: number }>()
);

export const setAppointmentStatusGridTenantId = createAction(
  '[Appointment Status Grid] Set Appointment Status Grid Tenant Id',
  props<{ tenantId: number }>()
);

export const setAppointmentStatusGridSearchFilter = createAction(
    '[Appointment Status Grid] Set Appointment Status Grid Search Filter',
    props<{ searchFilter: string }>()
);

export const removeAppointmentStatusGridSearchFilter = createAction(
    '[Appointment Status Grid] Remove Appointment Status Grid Search Filter'
);

export const setSubscribeToAppointmentStatusGrid = createAction(
    '[Appointment Status Grid] Set Subscribe To Appointment Status Grid'
);

export const subscribeToAppointmentStatusGridData = createAction(
    '[Appointment Status Grid] Subscribe To Appointment Status Grid Data',
    props<{ appointmentStatusGridFilter: AppointmentGridGroup }>()
);

export const reSubscribtionToAppointmentStatusGridData = createAction(
    '[Appointment Status Grid] Reload Subscribtion To Appointment Status Grid Data'
);

export const checkInAppointmentToLobby = createAction(
    '[Appointment Status Grid] CheckIn Appointment To Lobby',
    props<{ lobbyCheckIn: LobbyCheckIn }>()
);

export const updateAppointmentStatusToNoShow = createAction(
    '[Appointment Status Grid] Update Appointment Status To NoShow',
    props<{ confirmationNumber: string }>()
);

export const routeToAppointmentWidget = createAction(
    '[Appointment Status Grid] Route To Appointment Widget',
    props<{ confirmationNumber: string }>()
);

export const routeToAppointmentWidgetComplete = createAction(
    '[Appointment Status Grid] Route To Appointment Widget Complete',
);
export const setAppointmentStatusFromDate= createAction(
    '[Appointment Status Grid] Set Appointment Status From Date',
    props<{  fromDate: string, toDate: string  }>()
  );

  export const setAppointmentStatusToDate= createAction(
    '[Appointment Status Grid] Set Appointment Status To Date',
    props<{ toDate: string }>()
  );
